module.exports = __webpack_public_path__ + "img/ge.gefc9c4dc.svg";